import { Registry } from '@react-registry'

export const LI = () => {
    return {
        type: 'li',
    }
}

Registry.register(LI, { id: 'LI', registry: 'v2.deserializer' })